import { LOGO_URL } from "@/lib/brand";
import { ShieldCheck } from "lucide-react";

export function AuthShell({ title, subtitle, children, testid }) {
  return (
    <div className="min-h-screen bg-[#121412] text-white grid lg:grid-cols-[1.1fr_1fr]">
      <div className="hidden lg:flex flex-col justify-between p-14 relative overflow-hidden">
        <div className="absolute -left-40 -top-40 h-[520px] w-[520px] rounded-full bg-brand/30 blur-3xl" />
        <img src={LOGO_URL} alt="Casamore" className="relative h-24 w-auto self-start -ml-3 brightness-0 invert" />
        <div className="relative max-w-md">
          <p className="text-xs uppercase tracking-[0.3em] text-white/40">Gestionale aziendale</p>
          <h2 className="font-display text-5xl leading-tight mt-4">Dal primo contatto alla provvigione, in un unico posto.</h2>
          <p className="mt-6 text-white/50 text-sm flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-emerald-400" /> Accesso riservato a persone autorizzate dal titolare.</p>
        </div>
        <p className="relative text-xs text-white/30">Casamore Servizi Immobiliari · Corato (BA)</p>
      </div>
      <div className="flex items-center justify-center p-6 bg-warm text-anthracite">
        <div className="w-full max-w-sm" data-testid={testid}>
          <img src={LOGO_URL} alt="Casamore" className="h-16 w-auto mb-8 lg:hidden" />
          <h1 className="font-display text-4xl font-semibold">{title}</h1>
          {subtitle && <p className="text-sm text-anthracite/55 mt-2">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}

export function Field({ label, ...props }) {
  return (
    <label className="block mb-4">
      <span className="text-xs font-semibold text-anthracite/60">{label}</span>
      <input {...props} className="mt-1 w-full h-12 rounded-xl border border-border-subtle bg-white px-3 outline-none focus:border-brand focus:ring-2 focus:ring-brand/15 transition-[border-color,box-shadow]" />
    </label>
  );
}

export function Submit({ loading, children, ...props }) {
  return (
    <button type="submit" disabled={loading} {...props}
      className="w-full rounded-full bg-brand text-white font-semibold py-3.5 hover:bg-brand-hover active:scale-[0.99] transition-[background-color,transform] disabled:opacity-50">
      {loading ? "Attendere…" : children}
    </button>
  );
}

export function Notice({ kind = "error", children, testid }) {
  const cls = kind === "error" ? "bg-red-50 text-red-700 border-red-100" : "bg-emerald-50 text-emerald-800 border-emerald-100";
  return <div className={`mb-4 rounded-xl border px-4 py-3 text-sm ${cls}`} data-testid={testid}>{children}</div>;
}

export const PASSWORD_HINT = "Almeno 10 caratteri, con lettere e numeri.";
